import { render, staticRenderFns } from "./alimManage.vue?vue&type=template&id=53c8713e"
import script from "./alimManage.vue?vue&type=script&lang=js"
export * from "./alimManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c8713e')) {
      api.createRecord('53c8713e', component.options)
    } else {
      api.reload('53c8713e', component.options)
    }
    module.hot.accept("./alimManage.vue?vue&type=template&id=53c8713e", function () {
      api.rerender('53c8713e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/alim/alimManage.vue"
export default component.exports